// removed by extract-text-webpack-plugin
module.exports = {"modalHeader":"_2EYc8H9VJLwY4Pfi8_b-5I","linkButton":"_1-M3tPWGuFYuYVShGLUR8h"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/tos/tosForm.scss
// module id = 696
// module chunks = 22